import { ChevronLeft, ChevronRight } from "lucide-react";

const OPCIONES = [25, 50, 100];

export function Paginacion({ page, totalPages, total, pageSize, onPage, onPageSize, cargando }) {
  const desde = total === 0 ? 0 : (page - 1) * pageSize + 1;
  const hasta = Math.min(page * pageSize, total);
  return (
    <div data-testid="paginacion" className="flex flex-col sm:flex-row items-center justify-between gap-3 mt-4 text-sm">
      <div className="flex items-center gap-2 text-slate-500">
        <span data-testid="paginacion-rango">
          {total === 0 ? "Sin resultados" : `${desde}–${hasta} de ${total}`}
        </span>
        {cargando && <span className="text-indigo-500 animate-pulse">cargando…</span>}
      </div>
      <div className="flex items-center gap-3">
        <div className="flex items-center gap-1.5">
          <span className="text-slate-400 text-xs">Por página</span>
          <select data-testid="paginacion-tamano" value={pageSize}
            onChange={(e) => onPageSize(Number(e.target.value))}
            className="h-8 rounded-md border border-slate-200 bg-white px-2 text-sm outline-none focus:border-indigo-400">
            {OPCIONES.map((o) => <option key={o} value={o}>{o}</option>)}
          </select>
        </div>
        <div className="flex items-center gap-1">
          <button data-testid="paginacion-anterior" disabled={page <= 1 || cargando}
            onClick={() => onPage(page - 1)}
            className="h-8 w-8 flex items-center justify-center rounded-md border border-slate-200 text-slate-600 disabled:opacity-40 hover:bg-slate-50">
            <ChevronLeft size={16} />
          </button>
          <span data-testid="paginacion-actual" className="px-2 text-slate-600 tabular-nums">
            {page} / {totalPages}
          </span>
          <button data-testid="paginacion-siguiente" disabled={page >= totalPages || cargando}
            onClick={() => onPage(page + 1)}
            className="h-8 w-8 flex items-center justify-center rounded-md border border-slate-200 text-slate-600 disabled:opacity-40 hover:bg-slate-50">
            <ChevronRight size={16} />
          </button>
        </div>
      </div>
    </div>
  );
}
